import { SelectProps } from "@cloudscape-design/components/select";

export type Option = SelectProps.Option | null;

export const parameterTypeOptions = [
    { label: "Header", value: "header" },
    { label: "Query", value: "query" },
    { label: "Path", value: "path" }
];

export type RequestParameter = {
    name: string;
    type: "header" | "query" | "path";
};

export type ApiConfig = {
    environment: Option;
    serviceName: string;
    superStar: Option;
    aaaIdentifier: string;
    infrastructure: string;
    backendResourcePath: string;
    clientAuthorization: string;
    customActionExist: string;
    customAction: string;
    resourceUrnTemplate: string;
    corsEnabled: string;
    corsHeaders: string[];
    resource: string;
    httpMethod: Option;
    httpResourcePath: string;
    requiredParameters: RequestParameter[];
    optionalParameters: RequestParameter[];
};

export const defaultState: ApiConfig = {
    environment: null,
    serviceName: "",
    superStar: null,
    aaaIdentifier: "",
    infrastructure: "",
    backendResourcePath: "",
    clientAuthorization: "",
    customActionExist: "",
    customAction: "",
    resourceUrnTemplate: " ",
    corsEnabled: "",
    corsHeaders: [],
    resource: "",
    httpMethod: null,
    httpResourcePath: "",
    requiredParameters: [{ name: "", type: "header" }],
    optionalParameters: [{ name: "", type: "header" }],
};

export enum OnboardingStatus {
    ACCEPTED = "ACCEPTED",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED"
}